'use client';

import { useTranslations } from 'next-intl';
import { SettingsEditDialog } from '../settings/SettingsEditDialog';
import { SettingsSelectField } from './SettingsSelectField';
import { useApplicationEnvironmentSelectCollection } from './useApplicationGeneralCollections';
import { useDraftOnOpen } from './useDraftOnOpen';

export type ApplicationEnvironmentEditDialogProps = {
  open: boolean;
  environment: string;
  loading?: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (environment: string) => Promise<boolean>;
};

export function ApplicationEnvironmentEditDialog({
  open,
  environment,
  loading,
  onOpenChange,
  onSubmit,
}: ApplicationEnvironmentEditDialogProps) {
  const t = useTranslations('designSystem.applicationGeneral');
  const tCommon = useTranslations('designSystem.common');
  const collection = useApplicationEnvironmentSelectCollection();
  const [draftEnvironment, setDraftEnvironment] = useDraftOnOpen({
    open,
    value: environment,
  });

  return (
    <SettingsEditDialog
      open={open}
      title={t('editEnvironment')}
      onOpenChange={onOpenChange}
      onSubmit={async () => {
        if (await onSubmit(draftEnvironment)) {
          onOpenChange(false);
        }
      }}
      loading={loading}
      isSubmitDisabled={draftEnvironment === environment}
      submitText={tCommon('saveChanges')}
    >
      <SettingsSelectField
        label={t('environment')}
        collection={collection}
        value={draftEnvironment}
        onValueChange={setDraftEnvironment}
      />
    </SettingsEditDialog>
  );
}
